import { render, staticRenderFns } from "./NotificationMaterialObject.vue?vue&type=template&id=e931291c"
import script from "./NotificationMaterialObject.vue?vue&type=script&lang=js"
export * from "./NotificationMaterialObject.vue?vue&type=script&lang=js"
import style0 from "./NotificationMaterialObject.vue?vue&type=style&index=0&id=e931291c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports